import React, { useEffect, useState } from "react";
import AskmMeBotLogo from "../../../../../Assets/Images/Chatbot-ask-me.svg";
import CXLogo from "../../../../../Assets/Images/Logo-xsmall.svg";
import Navbar from "../Menu";
import Alert from "../../ShareElements/Alert/Alert";
import axios from "axios";
import { Config } from "../../../../../Config";
import ProfileMenu from "../../ShareElements/ProfileMenu/ProfileMenu";
import { ReactComponent as ChatbotIcon } from "../../../../../Assets/Images/Chatbot.svg";
import LanguageMenu from "../../ShareElements/LanguageMenu/LanguageMenu";
import NavBookmarksGuide from "../../UserGuide/Components/NavBookmarkGuide";
import HeaderGuide from "../../UserGuide/Components/HeaderGuide";

const MobileNav = (props) => {
  const [ConfirmIsOpen, setConfirmIsOpen] = useState(false);
  const [ProfileMenuIsOpen, setProfileMenuIsOpen] = useState(false);
  const [EmployeePos, setEmployeePos] = useState();
  const [LangMenuIsOpen, setLangMenuIsOpen] = useState(false); // used for displaying languages dropdown to change user's preferred language

  useEffect(() => {
    fetchEmpPositionInfo();
  }, []);

  const fetchEmpPositionInfo = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/current-position",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setEmployeePos(Res.data.title);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  // this function clicks the trigger for mobile navbar collapsible which is originally hidden
  const opneNavMenu = () => {
    let MenuIsOpen = !document.getElementById("menu-burger").checked;
    if (MenuIsOpen) {
      document.getElementById("navigation-menu").classList.remove("is-open");
    } else {
      document.getElementById("navigation-menu").classList.add("is-open");
    }
  };
  const handleLogout = () => {
    window.localStorage.clear();
    window.location.assign("/");
  };
  const handleCountDisplay = (Count) => {
    if (Count >= 100) {
      return "99+";
    } else {
      return Count;
    }
  };
  return (
    <React.Fragment>
      {ConfirmIsOpen ? (
        <Alert
          AlertText={"Logout Account?"}
          AlertInfo={"Are you sure you want to log out?"}
          AcceptText={"Logout"}
          IsDelete={false}
          cancel={() => setConfirmIsOpen(false)}
          accept={() => handleLogout()}
        />
      ) : null}
      {props.HeaderGuideIsOpen ? (
        <div className="overlay" style={{ zIndex: "99" }}></div>
      ) : null}
      {props.HeaderGuideIsOpen ? (
        <HeaderGuide
          LangData={props.LangData}
          TogglePreviousDialog={() => props.ToggleSeventhGuide()}
          CloseGuide={() => props.CloseGuide()}
          JumpToStep={(Step) => props.JumpToStep(Step)}
          UpdateWalkthrough={(Bool) => props.UpdateWalkthrough(Bool)}
        />
      ) : null}

      {props.NavBookmarksGuideIsOpen ? (
        <div className="overlay" style={{ zIndex: "1000" }}></div>
      ) : null}
      {props.NavBookmarksGuideIsOpen ? (
        <div className="mobile-nav-shadow-box" style={{ zIndex: "1001" }}>
          <label for="menu-burger">
            <div className="burger-line"></div>
            <div className="burger-line"></div>
            <div className="burger-line"></div>
          </label>
          <NavBookmarksGuide
            LangData={props.LangData}
            ToggleNextDialog={() => props.ToggleSixthGuide()}
            JumpToStep={(Step) => props.JumpToStep(Step)}
            TogglePreviousDialog={() => props.ToggleFourthGuide()}
          />
        </div>
      ) : null}
      <div className="nav-header" id="mobile-nav-header">
        {props.HeaderGuideIsOpen ? (
          <div className="sm-navbar-overlay"></div>
        ) : null}
        <div id="navigation-menu" className="navigation-menu">
          <Navbar
            LangData={props.LangData}
            setConfirmLogoutIsOpen={(Bool) =>
              props.setConfirmLogoutIsOpen(Bool)
            }
          />
        </div>

        <div className="header">
          <span className="profile-menu-holder">
            {ProfileMenuIsOpen ? (
              <ProfileMenu
                UserInfo={props.UserInfo}
                Close={() => setProfileMenuIsOpen(false)}
                LangData={props.LangData}
                EmployeePos={EmployeePos}
                UpdateWalkthrough={(Bool) => props.UpdateWalkthrough(Bool)}
              />
            ) : null}
          </span>
          <span className="profile-menu-holder">
            {LangMenuIsOpen ? (
              <LanguageMenu
                SelectedLanguage={props.UserLanguage}
                Close={() => setLangMenuIsOpen(false)}
                SetLanguage={(Lang) => props.SetPreferredLanguage(Lang)}
              />
            ) : null}
          </span>
          <button
            className="lang-toggle"
            onClick={
              props.HeaderGuideIsOpen ? null : () => setLangMenuIsOpen(true)
            }
          >
            <i className="feather-globe"></i>
            <p>{props.UserLanguage}</p>
          </button>
          <button
              className={
                props.HasNotifications
                    ? "notifications-trigger with-notifs"
                    : "notifications-trigger"
              }
              onClick={
                props.HeaderGuideIsOpen ? null : () => props.ToggleNotifications()
              }
          >
            <i className="feather-bell"></i>
            {props.UnreadEventsNotifs + props.UnreadMessagesNotifs > 0 ? (
                <span className="reminder-spot">
                {handleCountDisplay(
                    props.UnreadEventsNotifs + props.UnreadMessagesNotifs
                )}
              </span>
            ) : null}
          </button>
          <ChatbotIcon
            className="chatbot-icon user-image"
            onClick={
              props.HeaderGuideIsOpen ? null : () => props.ToggleChatbot()
            }
          />
          <button
            className="notifications-trigger"
            onClick={
              props.HeaderGuideIsOpen ? null : () => props.ToggleAskMeBot()
            }
          >
            <img src={AskmMeBotLogo} />
          </button>
          <button>
            <i className="feather-grid"></i>
          </button>
        </div>
        <div id="nav-header">
          <input
            type="checkbox"
            onChange={() => opneNavMenu()}
            id="menu-burger"
          />
          <label for="menu-burger">
            <div className="burger-line"></div>
            <div className="burger-line"></div>
            <div className="burger-line"></div>
          </label>
          {props.UserInfo.imageThumbnailUrl === null ? (
            <span
              className="user-avatar-mobile avatar-placeholder"
              style={{
                backgroundColor: props.UserInfo.backgroundColorCode,
                color: props.UserInfo.textColorCode,
              }}
              onClick={
                props.HeaderGuideIsOpen
                  ? null
                  : () => setProfileMenuIsOpen(true)
              }
            >
              {props.UserInfo.firstName.slice(0, 1).toUpperCase() +
                props.UserInfo.lastName.slice(0, 1).toUpperCase()}
            </span>
          ) : (
            <img
              className="user-avatar-mobile user-image"
              alt=""
              onClick={
                props.HeaderGuideIsOpen
                  ? null
                  : () => setProfileMenuIsOpen(true)
              }
              src={props.UserInfo.imageThumbnailUrl}
            />
          )}
          <img alt="" src={CXLogo} className="x-small-logo" />
        </div>
      </div>
    </React.Fragment>
  );
};
export default MobileNav;
